<div class=" mt-4" >
  <section class="my-4">

  </section>
  <div class="scrollmenu">

    <a class="active menu" [routerLink]="['/PayOut/PayoutReports']">PayOut Reports</a>

    <a [routerLink]="['/PayOut/PayoutPostback']">PayOut Webhook Url</a>
    <a [routerLink]="['/PayOut/Payoutwebhookdata']">PayOut Webhook Data</a>
    <a [routerLink]="['/PayOut/PayoutLedger']">PayOut Ledger</a>
    <a [routerLink]="['/reports/payoutorderfailurelog']">PayOut Failure </a>
  </div>
  <section>

    <div class="row mb-3">
      <div class="col-md-12">
        <div class="float-right">
          <!-- <a  class="back-tour mr-3" type="a" data-bs-toggle="modal" data-bs-target="#exampleModalCenter">Need Help ?
            Take a Tour<i class="far fa-lightbulb"></i></a> -->
          <div class="dropdown d-inline">
            <button class="dash-btns mr-3" type="button" data-bs-toggle="dropdown">Download &nbsp;<i
                class="fas fa-caret-down"></i>
            </button>
            <ul class="dropdown-menu text-center">
              <li><a  id="btnExportBatch" (click)="readAndExportToExcelData()">Excel</a></li>

            </ul>
          </div>
          <!-- <a class="box-button" type="button" id="filtering" (click)="filters()" tooltip="Filter"
        aria-describedby="tooltip-9">  <img src="assets/img/filter-icon.png" alt="" style="width: 20px; height: 20px;"></a>
      -->
          <button class="btn dash-btns" type="button" id="filtering" (click)="filters()"> <i class="fa fa-filter" aria-hidden="true"></i>Filter</button>

        </div>

      </div>
      <div class="col-md-12">
        <small class=" font-16 gary-t ">Currently we are displaying last 7 days report. For more details please click
          onFilter</small>
      </div>
    </div>

    <div class="row  my-4" *ngIf="filtering">
      <div class="col-md-12">
        <div class="card-1 p-4">
          <h4 class="font-26 gary-t">Filter Your Result</h4>
          <p>Please Fill the details to filter your result</p>

          <div class="col-md-12">
            <!-- filtering starts -->
            <form>
              <div class="row m-0">
                <div class="col-md-3 mt-4">

                  <div class="form-group">
                    <label class="customlabel">Date</label>
                    <div class="selectcustom">
                      <ngx-select [items]="Range" id="daterange" placeholder="Today" [formControl]="daterange"
                      (ngModelChange)="checkRangeType()" required>
                    </ngx-select>
                    </div>

                  </div>
                </div>
                <div class="col-md-3 mt-4" *ngIf="Rfromdate">


                  <div class="form-group">
                    <label class="customlabel">From Date</label>
                    <input class="formcontrol-user1 form-control" type="date" placeholder="From Date" id="fromdate"
                      [formControl]="fromdate"  (change)="checkDateRange()">
                  </div>

                </div>
                <div class="col-md-3 mt-4" *ngIf="Rfromdate">

                  <div class="form-group">
                    <label class="customlabel">To Date</label>
                    <input class="formcontrol-user1 form-control" type="date" placeholder="To Date" id="todate"
                      [formControl]="todate"  (change)="checkDateRange()">
                  </div>
                </div>
                <span class="text-danger" *ngIf="isStartDateGreaterthenEndDate">From Date Should not be greater than To
                  Date</span>
                <!-- <div class="col-md-3  mt-4">
              <div class="form-group">
                <ngx-select [items]="Status" id="BankAccountType" placeholder="BankAccountType" [formControl]="BankAccountType" required>
                </ngx-select>
              </div>
            </div> -->
                <div class="col-md-3  mt-4">

                  <div class="form-group">
                    <label class="customlabel">Transaction ID</label>
                    <input class="formcontrol-user1 form-control" type="text" placeholder="Transaction Id"
                      id="TransactionId" [formControl]="TransactionId">
                  </div>
                </div>
                <div class="col-md-3 mt-4">

                  <div class="form-group">
                    <label class="customlabel">Status</label>
                    <div class="selectcustom mb-0">
                      <ngx-select [items]="Statuslist" id="Status" placeholder="Status" [formControl]="Status"
                      required>
                    </ngx-select>
                    </div>

                  </div>
                </div>
                <div class="col-md-3 mt-4">

                  <div class="form-group">
                    <label class="customlabel">Transaction Type</label>
                    <div class="selectcustom mb-0">
                      <ngx-select [items]="TTypelist" id="TransactionType" placeholder="Transaction Type" [formControl]="TransactionType"
                      required>
                    </ngx-select>
                    </div>

                  </div>
                </div>
                <div class="col-md-3 mt-4">

                  <div class="form-group">
                    <label class="customlabel">Payment Type</label>
                    <div class="selectcustom mb-0">
                      <ngx-select [items]="Ptypelist" id="PaymentType" placeholder="Payment Type" [formControl]="PaymentType"
                      required>
                    </ngx-select>
                    </div>

                  </div>
                </div>
                <div class="col-md-3  mt-4">
                  <label class="customlabel">Payout Customer keyId</label>
                  <div class="form-group">
                    <input class="formcontrol-user1 form-control" type="text" placeholder="Payout Customer keyId" id="PayoutCustomerkeyId"
                      [formControl]="PayoutCustomerkeyId">
                  </div>
                </div>
                <div class="col-md-3  mt-4">
                  <label class="customlabel">PayOut Beneficiary KeyId</label>
                  <div class="form-group">
                    <input class="formcontrol-user1 form-control" type="text" placeholder="PayOut Beneficiary KeyId" id="PayOutBeneficiaryKeyId"
                      [formControl]="PayOutBeneficiaryKeyId">
                  </div>
                </div>

                <div class="col-md-3  mt-4">

                  <div class="form-group">
                    <label class="customlabel">Account Number</label>
                    <input class="formcontrol-user1 form-control" type="text" placeholder="Account Number"
                      id="AccountNumber" [formControl]="AccountNumber">
                  </div>
                </div>
                <div class="col-md-3  mt-4">

                  <div class="form-group">
                    <label class="customlabel">Amount</label>
                    <input class="formcontrol-user1 form-control" type="text" placeholder="Amount" id="Amount"
                      [formControl]="Amount">
                  </div>
                </div>
                <div class="col-md-3 mt-4">

                  <div class="form-group">
                    <label class="customlabel">Select</label>
                    <div class="selectcustom mb-0">
                      <ngx-select [items]="symbol" id="amountcheck" placeholder="Select" [formControl]="amountcheck"
                      required>
                    </ngx-select>
                    </div>

                  </div>
                </div>
                <!-- <div class="col-md-3  mt-4">
              <div class="form-group">
                <input type="text" placeholder="PayOutKeyId" id="PayOutKeyId" [formControl]="PayOutKeyId">
              </div>
            </div> -->
              </div>
            </form>
            <!-- filtering ends -->
          </div>
          <div class="col-md-12 text-right">
            <div class="text-right" *ngIf="!isCustomDateSelected">
              <button class="dash-btns" type="button" id="filtering" (click)="selectedaterange()"
                matTooltip="New Sale Transaction"> Search</button>
            </div>

            <div class="text-right pt-2" *ngIf="isCustomDateSelected">
              <button class="dash-btns" type="button" id="filtering" [disabled]="!isreportsbtnActive" (click)="search()"
                matTooltip="New Sale Transaction"> Search</button>
            </div>
            <!-- <a href="" style="color: #d40055;">Clear</a> -->
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <ngx-datatable #table class='bootstrap no-detail-row' (columnMode)="'Force'" [footerHeight]="50"
          [rowHeight]="'auto'"[columnMode]="'force'" [scrollbarH]="true" [limit]="10" [rows]="rows" >
          <ngx-datatable-column name="Action">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <a class=" edit" [routerLink]="['/PayOut/ViewPayOutTransactions',{Id: row.TransactionId}]"
                data-toggle="tooltip" data-placement="top" title="View">
                <img src="./assets/ViewDetails.svg">
              </a>
              <a class="edit btn btn-demo" (click)="viewtransactiondetails(row.TransactionId,row.MerchantKeyId)" data-bs-toggle="modal" data-bs-target="#myModal2" data-bs-placement="top" title="Basic View">
                <em class="fa-1x mr-2 fas fa-eye"></em>
              </a>
              <!-- <a class=" edit pl-1 d-inline"
              [routerLink]="['/PayOut/ViewPayOutTransactions',{Id: row.Id}]"
                            data-toggle="tooltip" data-placement="top" title="Edit"
                            > <i class="fas fa-edit"></i>
                        </a> -->

            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Status" [width]="180">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span class="status-warning-btn" *ngIf="row.Status==0">
                Pending
              </span>
              <span class="status-primary-btn" *ngIf="row.Status==1">
                Transaction Initiated
              </span>
              <span class="status-danger-btn" style="display: inline-block" *ngIf="row.Status==2">
                Failed
              </span>
              <span class="status-approved-btn" *ngIf="row.Status==3">
                Transferred
              </span>
              <span class="status-danger-btn" *ngIf="row.Status==4">
                Cancelled
              </span>
              <span class="status-danger-btn" *ngIf="row.Status==5">
                WaitingForApproval
              </span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Response" [width]="200">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.ResponseText}}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Transaction Id" [width]="200">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.TransactionId}}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Transaction Type">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class="robot font400">{{row.TransactionType}}</div>
            </ng-template>

          </ngx-datatable-column>
          <ngx-datatable-column name="Payment Type">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.PaymentType}}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Amount">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class=" text-right robot font400"> {{row.Amount | currency:"₹" }}</div>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Request UniqueId">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class=" text-right robot font400"> {{row.RequestUniqueId }}</div>
            </ng-template>
          </ngx-datatable-column>


          <ngx-datatable-column name="Payout Customer keyId">
            <ng-template let-row="row" ngx-datatable-cell-template>
            <a class=" edit" [routerLink]="['/PayOut/ViewPayOutContact',{Id: row.Contactid}]" data-toggle="tooltip"
            data-placement="top" title="View">
              <div > {{row.PayoutCustomerkeyId  }}</div>
            </a>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="FirstName">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div> {{row.FirstName}}</div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="LastName">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div > {{row.LastName }}</div>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="MobileNo" [width]="200">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.MobileNo}}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="PayOut Beneficiary KeyId" [width]="200">

            <ng-template let-row="row" ngx-datatable-cell-template>
              <a class=" edit" [routerLink]="['/PayOut/ViewBeneficiaries',{Id: row.Beneficiaryid}]" data-toggle="tooltip"
              data-placement="top" title="View">
               {{row.PayOutBeneficiaryKeyId}}
               </a>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Beneficiary Name">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.BeneficiaryName}} </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="BankName">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.BankName}} </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Account Number">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.AccountNumber}} </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Transaction Datetime">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class=" robot font400">{{row.UpdatedDatetime| date:'d/M/yy, h:mm a'}}</div>
            </ng-template>
          </ngx-datatable-column>




        </ngx-datatable>
      </div>
    </div>
  </section>
</div>
<div class="modal right fade" id="myModal2" tabindex="-1" role="dialog" aria-labelledby="myModalLabel2">
  <div class="modal-dialog" role="document">
    <div class="modal-content">

      <div class="modal-header">
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
         <h4 class="modal-title" id="myModalLabel2">View Transaction Details</h4>
      </div>

      <div class="modal-body">
        <div class="row mt-3 mb-3">
          <div class="col-md-12">
            <div class="row  my-3">
                <div class="col-md-6">
                    <label>Status</label>
                </div>
                <div class="col-md-6">
                    <div class="view-text"> <span class="text-warning" *ngIf="rowdata.Status==0">
                      Pending
                    </span>
                    <span class="text-success" *ngIf="rowdata.Status==1">
                      Transaction Initiated
                    </span>
                    <span class="text-danger" *ngIf="rowdata.Status==2">
                      Failed
                    </span>
                    <span class="text-success" *ngIf="rowdata.Status==3">
                      Transferred
                    </span>
                    <span class="text-danger" *ngIf="rowdata.Status==4">
                      Cancelled
                    </span>
                    <span class="text-danger" *ngIf="rowdata.Status==5">
                     Waiting For Approval
                    </span> </div>


                </div>
            </div>
            <div class="row my-3">
                <div class="col-md-6">
                    <label>Amount
                    </label>
                </div>
                <div class="col-md-6">
                    <div class="view-text"> {{rowdata.Amount}}</div>
                </div>
            </div>
            <div class="row my-3">
                <div class="col-md-6"> <label>TransactionId</label> </div>

                <div class="col-md-6 view-text "> {{rowdata.TransactionId}}
                </div>
            </div>
            <div class="row my-3">
                <div class="col-md-6"> <label>GST Amount</label> </div>

                <div class="col-md-6 view-text  ">{{rowdata.GSTAmount}} </div>
            </div>

            <div class="row my-3">
                <div class="col-md-6">
                    <label>Total Amount </label>
                </div>
                <div class="col-md-6 view-text "> {{rowdata.Amount + rowdata.TotalFeeAmount | number : '1.2-2'}}</div>
            </div>
            <div class="row my-3">
                <div class="col-md-6">
                    <label>Fee Amount</label>
                </div>
                <div class="col-md-6 view-text">{{rowdata.FeeAmount}}</div>
            </div>
            <div class="row my-3">
                <div class="col-md-6">
                    <label>Total Fee Amount </label>
                </div>
                <div class="col-md-6 view-text">{{rowdata.TotalFeeAmount}}</div>
            </div>
            <div class="row my-3">
                <div class="col-md-6">
                    <label>Transaction Type</label>
                </div>
                <div class="col-md-6 view-text">{{rowdata.TransactionType}}
                </div>
            </div>



            <div class="row my-3">

                <div class="col-md-6">
                    <label>PaymentType</label>
                </div>

                <div class="col-md-6 view-text">{{rowdata.PaymentType}}</div>
            </div>

            <div class="row my-3">
                <div class="col-md-6">
                    <label>PayOut Beneficiary KeyId </label>
                </div>

                <div class="col-md-6 view-text">{{rowdata.PayOutBeneficiaryKeyId}}</div>
            </div>
            <div class="row my-3">
                <div class="col-md-6">
                    <label>Payout CustomerkeyId</label>
                </div>

                <div class="col-md-6 view-text">{{rowdata.PayoutCustomerkeyId}}</div>
            </div>






        </div>
        <div class="col-md-12">
            <div class="row my-3">

                <div class="col-md-6">
                    <label>Bank Code Type </label>
                </div>

                <div class="col-md-6 view-text">{{rowdata.BankCodeType}}</div>
            </div>
            <div class="row my-3">

                <div class="col-md-6">
                    <label> BankName</label>
                </div>

                <div class="col-md-6 view-text robot">{{rowdata.BankName}} </div>
            </div>
            <div class="row my-3">

                <div class="col-md-6">
                    <label>UTRNo </label>
                </div>

                <div class="col-md-6 view-text">{{rowdata.UTRNo}} </div>

            </div>

            <div class="row my-3">

                <div class="col-md-6">
                    <label>PayOut Date </label>
                </div>

                <div class="col-md-6 view-text">{{rowdata.PayOutDate |
                  date:'d/M/yy, h:mm a' }}</div>

            </div>

            <div class="row my-3">

              <div class="col-md-6">
                  <label>PayOut KeyId </label>
              </div>

              <div class="col-md-6 view-text">{{rowdata.PayOutKeyId}}</div>

          </div>
          <div class="row my-3">

            <div class="col-md-6">
                <label>PayOut Type </label>
            </div>

            <div class="col-md-6 view-text">{{rowdata.PayOutType}}</div>

        </div>
        <div class="row my-3">

          <div class="col-md-6">
              <label>AccountNumber </label>
          </div>

          <div class="col-md-6 view-text">{{rowdata.AccountNumber}}</div>

      </div>
      <div class="row my-3">

        <div class="col-md-6">
            <label>Branch Name </label>
        </div>

        <div class="col-md-6 view-text">{{rowdata.BranchName }}</div>

    </div>
    <div class="row my-3">

      <div class="col-md-6">
          <label>BankCode/IFSC Code </label>
      </div>

      <div class="col-md-6 view-text">{{rowdata.BankCode }}</div>

  </div>



    <div class="row my-3">

      <div class="col-md-6">
          <label>Beneficiary Name </label>
      </div>

      <div class="col-md-6 view-text">{{rowdata.BeneficiaryName }}</div>

  </div>
  <div class="row my-3">

    <div class="col-md-6">
        <label>Bank Account Type </label>
    </div>

    <div class="col-md-6 view-text">{{rowdata.BankAccountType }}</div>

</div>
<div class="row my-3">

  <div class="col-md-6">
      <label>Request Reference No</label>
  </div>

  <div class="col-md-6 view-text">{{rowdata.RequestReferenceNo }}</div>

</div>
<div class="row my-3">

  <div class="col-md-6">
      <label>Request UniqueId</label>
  </div>

  <div class="col-md-6 view-text">{{rowdata.RequestUniqueId }}</div>

</div>
<div class="row my-3">

  <div class="col-md-6">
      <label>Response Text</label>
  </div>

  <div class="col-md-6 view-text">{{rowdata.ResponseText }}</div>

</div>
<div class="row my-3">

  <div class="col-md-6">
      <label>Response Reason Code</label>
  </div>

  <div class="col-md-6 view-text">{{rowdata.ResponseReasonCode }}</div>

</div>
<div class="row my-3">

  <div class="col-md-6">
      <label>Updated Date time</label>
  </div>

  <div class="col-md-6 view-text">{{rowdata.UpdatedDatetime| date:'d/M/yy,
    h:mm a'}}</div>

</div>





        </div>
        </div>
      </div>

    </div><!-- modal-content -->
  </div><!-- modal-dialog -->
</div>

